export default __webpack_public_path__ + "img/tremors/tremors6_src.webp";